import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import ModalBtns from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns'
import Drawer from '@groovehq/internal-design-system/lib/components/Drawer/UnmanagedDrawer'
import image from '@groovehq/internal-design-system/lib/assets/images/users.png'
import HeaderWithImage from '@groovehq/internal-design-system/lib/components/HeaderWithImage/HeaderWithImage'

import { bool } from 'prop-types'
import { doCreateInvitations } from 'ducks/agents/operations'

import { yupResolver } from '@hookform/resolvers/yup'
import { isValidEmail } from 'util/strings'
import * as yup from 'yup'

import { useForm } from 'react-hook-form'
import AddRows from './AddRows'

const extractValidFields = fields => {
  return fields
    .filter(field => !!field.email)
    .filter(field => isValidEmail(field.email))
}

// eslint-disable-next-line func-names
yup.addMethod(yup.array, 'userInvitations', function() {
  // eslint-disable-next-line func-names
  return this.test(`user-invitations`, 'errorMessage', function(value) {
    const { path, createError } = this
    let isValid = false
    if (value) {
      const validFields = extractValidFields(value)
      if (validFields.length > 0) isValid = true
    }

    return isValid || createError({ path, message: 'Not valid' })
  })
})

const ROWS_FORM_SCHEMA = yup.object().shape({
  user: yup
    .array()
    .userInvitations()
    .of(
      yup.object().shape({
        email: yup.string(),
        role: yup.string(),
      })
    ),
})

const BULK_FORM_SCHEMA = yup.object().shape({
  bulkEmails: yup.string(),
})

const AgentAddDrawer = props => {
  const { open, onClose, setSendMode } = props
  const sendMode = 'rows'

  const dispatch = useDispatch()

  const formSchema = sendMode === 'rows' ? ROWS_FORM_SCHEMA : BULK_FORM_SCHEMA

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(formSchema),
    defaultValues: {
      bulkRole: 'agent',
      bulkEmails: '',
      user: [
        { email: '', role: 'agent' },
        { email: '', role: 'agent' },
        { email: '', role: 'agent' },
      ],
    },
  })

  const handleOnClose = useCallback(
    () => {
      const closeOptions = {}
      onClose(closeOptions)
    },
    [onClose]
  )

  const onSubmit = useCallback(
    data => {
      const users = extractValidFields(data.user).map(field => ({
        email: field.email,
        role: field.role,
      }))
      dispatch(doCreateInvitations(users))
      handleOnClose()
    },
    [dispatch, handleOnClose]
  )

  const DrawerForm = useCallback(
    subprops => <form onSubmit={handleSubmit(onSubmit)} {...subprops} />,
    [handleSubmit, onSubmit]
  )

  const footer = (
    <ModalBtns
      saveBtnDisabled={!isValid}
      saveBtnText="Invite to Groove"
      // type="submit" will automatically trigger the form submit event when clicked
      saveBtnHtmlType="submit"
      tertiaryBtnText="Cancel"
      onClickTertiaryBtn={onClose}
    />
  )

  return (
    <Drawer
      title="Add a team member"
      open={open}
      onClose={onClose}
      footer={footer}
      container={DrawerForm}
    >
      <HeaderWithImage
        imgWidth="120px"
        img={image}
        title="Invite via email..."
        className="grui mb-14"
      />{' '}
      <AddRows setSendMode={setSendMode} control={control} />
    </Drawer>
  )
}

AgentAddDrawer.propTypes = {
  open: bool.isRequired,
}

AgentAddDrawer.defaultProps = {}

export default AgentAddDrawer
